import Vue from 'vue'
import Vuex from 'vuex'
import getters from '@/store/getters'
// vuex模块引入
import Bluetooth from '@/store/modules/bluetooth' // 存储蓝牙设备信息
import init from '@/store/modules/init'// 公共配置数据
import user from '@/store/modules/user'// 公共配置数据
import stockUp from '@/store/modules/stockup'// 备货
import outbound from '@/store/modules/outbound'// 备货
import customAvatar from '@/store/modules/customAvatar'// 备货


// vue使用vuex;
Vue.use(Vuex)

export default new Vuex.Store({
  // 开启严格模式,仅开发模式下启用,发布环境下取消
  strict: true,
  modules: {
    Bluetooth,
    init,
    user,
    stockUp,
    outbound,
    customAvatar
  },
  getters
})
